import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  DeviceStatus,
  deviceStatusLabel,
  normalizeDeviceStatus,
} from 'src/app/features/tests/features/constants';
import { INACTIVE_STATUS_LABEL } from '../../services/device-activation.type';



@Component({
  selector: 'app-status-indicator',
  templateUrl: './status-indicator.component.html',
  imports: [CommonModule]
})
export class StatusIndicatorComponent {
  @Input() status!: string;
  @Input() isWithoutText? = false
  @Input() online? = undefined
  /**
   * The device has been taken out of the lab's active inventory. Its stored
   * status is untouched (it keeps the stage it was in), so the stage is not what
   * a reader needs here — being out of service is. Shown in its place.
   */
  @Input() inactive = false;


  deviseStatusEnum = DeviceStatus;

  /**
   * The stored status carries internal inspection wording, so the dot compares
   * against the canonical value and the text shows the user-facing label. In Lab
   * equipment statuses are plainly worded ("Available" with no inspection
   * suffix) and resolve to the same canonical values, so they share the colours.
   */
  get canonicalStatus(): string {
    return normalizeDeviceStatus(this.status) ?? this.status;
  }

  get label(): string {
    return this.inactive ? INACTIVE_STATUS_LABEL : deviceStatusLabel(this.status);
  }
}
